<template>
    <div class="row">
        <div class="col position-relative p-3" style="border: solid 1px #8f8f8f;">
            <h3>Your Account at a Glance:</h3>
            <p v-for="n in accountMessages" v-html="n.html"></p>
        </div>
    </div>
</template>
<script>
export default {
    name: "AccountGlanceWidget",
    props: ["user"],
    data() {
        return {
            accountMessages: [
                {
                    html:
                        "<p>You requested PTO days off<br>Dates Nov 9, 2018 - Nov 10, 2018 (16hrs)<br>Status: Pending",
                },
                { html: "<p>Your performance review is coming up 5-16-18" },
            ],
        };
    },
    methods: {
        fetchAccountNotifications() {
            let endpoint = "";
            axios.post(endpoint).then(r => {
                this.accountMessages = r.data.accountMessages;
            });
        },
    },
};
</script>
